<template>
	<section id="home">
		<vue-p5 @sketch="sketch"></vue-p5>

		<FirstRun v-bind:user="user"></FirstRun>
	</section>
</template>

<script>
import VueP5 from 'vue-p5';
import FirstRun from "../components/FirstRun"

export default {
	props: ['user'],
	components: { FirstRun, VueP5 },
	data: function () {
		return {
			camera: null,
			scene: null,
			renderer: null,
			mesh: null
		}
	},
	created() {
		if (this.user.first_visit != true) {
			this.$router.push('/prompt');
		}
	},
	methods: {
		sketch(sk) {
			// const clicks = [];

			var font = "Georgia";

			var textTyped = "In August 1992, when the dog days were drawing to an end, I set off to walk the county of Suffolk, in the hope of dispelling the emptiness that takes hold of me whenever I have completed a long stint of work. And in fact my hope was realized, up to a point; for I have seldom felt so carefree as I did then, walking for hours in the day through the thinly populated countryside, which stretches inland from the coast. I wonder now, however, whether there might be something in the old superstition that certain ailments of the spirit and of the body are particularly likely to beset us under the sign of the Dog Star. At all events, in retrospect I became preoccupied not only with the unaccustomed sense of freedom but also with the paralysing horror that had come over me at various times when confronted with the traces of destruction, reaching far back into the past, that were evident even in that remote place. Perhaps it was because of this that, a year to the day after I began my tour, I was taken into hospital in Norwich in a state of almost total immobility. It was then that I began in my thoughts to write these pages. I can remember precisely how, upon being admitted to that room on the eighth floor, I became overwhelmed by the feeling that Suffolk expanses I had walked the previous summer had now shrunk once and for all to a single, blind, insensate spot. Indeed, all that could be seen of the world from my bed was the colourless patch of sky framed in the window.";

			var fontSize = 65;
			// var padding = 10;
			var pointDensity = 5;

			// var paths;
			var textImg;

			var rads = sk.radians(Math.random()*360);

			// sk.preload = () => {
			// 	font = sk.loadFont('FiraSansCondensed-Bold.otf');
			// }

			sk.setup = () => {
				sk.createCanvas(window.innerWidth, window.innerHeight);
				sk.frameRate(25);
				sk.rectMode(sk.CENTER);

				sk.pixelDensity(1);

				sk.setupText();
			}

			sk.setupText = () => {
				// create an offscreen graphics object to draw the text into
				textImg = sk.createGraphics(sk.width, sk.height);
				textImg.pixelDensity(1);
				textImg.background(255);
				textImg.textFont(font);
				textImg.textAlign(sk.LEFT)
				textImg.textSize(fontSize);
				textImg.text(textTyped, 0, 0, sk.width+(fontSize*15), sk.height+100);
				textImg.loadPixels();

				sk.background('#f1f1f1');

				for (var x = 0; x < textImg.width; x += pointDensity) {
					for (var y = 0; y < textImg.height; y += pointDensity) {
						// Calculate the index for the pixels array from x and y
						var index = (x + y * textImg.width) * 4;
						// Get the red value from image
						var r = textImg.pixels[index];

						if (r < 128) {
							sk.strokeWeight(1);

							// var lengthFac = sk.map((sk.frameCount % 100), 0, 100, 0.1, 1);
							var lengthFac = 0.1;

							sk.stroke(sk.color(10,10,10));

							sk.push();
							sk.translate(x, y);
							sk.rotate(rads);
							sk.line(0, 0, fontSize * lengthFac, 0);
							sk.pop();
						}
					}
				}
			}

			sk.windowResized = () => {
				sk.resizeCanvas(window.innerWidth, window.innerHeight);
				sk.setupText();
			}
		}
	}
}
</script>

<style>
	#firstRun {
		background: #eee;
		padding: 1em;
		float: left;
	}

	canvas {
		position: absolute;
		top: 0;
		left: 0;
	}

	/* #dataViz {
		width: auto;
		float: left;
		margin-left: 2em;
	} */
</style>
